import './reSetWidthHeight.less';
import './initPxToRem';
import Vue from 'vue'
import 'vant/lib/index.css';
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant';
import App from './App.vue';
import { Dialog } from 'vant';

// 全局注册
Vue.use(Dialog);
Vue.use(elementUI)
Vue.use(Vant)

Vue.config.productionTip = false;   // 禁用 "You are running Vue in development mode" 的提示
Vue.config.devtools = false;        // 禁用开发工具的连接

new Vue({
  render: h => h(App),
}).$mount('#app')
